import { Icon, IconName } from "@zapier/zinnia-icons";
import {
  Button,
  ButtonProps,
  Link,
  LinkProps,
  Tooltip,
  TooltipFocusableTrigger,
} from "@zapier/design-system";
import styles from "./HeaderButton.module.css";

interface HeaderButtonProps {
  icon: IconName;
  ariaLabel?: string;
  tooltipContent?: string;
  href: string;
  buttonText: string;
  buttonColor?: LinkProps["variant"];
  iconButtonColor?: LinkProps["variant"];
  target?: LinkProps["target"];
  isDisabled?: boolean;
  onClick?: () => void;
}

export function HeaderButton({
  icon,
  ariaLabel,
  tooltipContent,
  href,
  buttonText,
  iconButtonColor = "ghost",
  buttonColor = "ghost",
  target,
  isDisabled = false,
  onClick,
}: HeaderButtonProps) {
  const tooltip = tooltipContent || buttonText;
  const iconLabel = ariaLabel || tooltipContent || buttonText;

  return (
    <>
      <div className={styles.iconButtonWrapper}>
        <Tooltip content={tooltip} placement="bottom" allowMultiline={true}>
          {isDisabled ? (
            // A disabled Button is not focusable, so it needs the wrapper to
            // receive focus and hover on its behalf.
            <TooltipFocusableTrigger>
              <Button
                aria-label={iconLabel}
                aria-disabled="true"
                variant={iconButtonColor as ButtonProps["variant"]}
                isDisabled={isDisabled}
              >
                <Icon name={icon} />
              </Button>
            </TooltipFocusableTrigger>
          ) : (
            <Link
              href={href}
              aria-label={iconLabel}
              variant={iconButtonColor}
              onClick={onClick}
            >
              <Icon name={icon} />
            </Link>
          )}
        </Tooltip>
      </div>

      <div className={styles.regularButtonWrapper}>
        <Tooltip content={tooltip} placement="bottom" allowMultiline={true}>
          {isDisabled ? (
            <TooltipFocusableTrigger>
              <Button
                aria-disabled="true"
                variant={buttonColor as ButtonProps["variant"]}
                isDisabled={isDisabled}
              >
                <Icon name={icon} />
                {buttonText}
              </Button>
            </TooltipFocusableTrigger>
          ) : (
            <Link
              href={href}
              target={target}
              variant={buttonColor}
              onClick={onClick}
            >
              <Icon name={icon} />
              {buttonText}
            </Link>
          )}
        </Tooltip>
      </div>
    </>
  );
}
